import React, { useState } from 'react'
import { Hidden, Typography } from '@material-ui/core'
import HelpSvg from 'images/icons/fc-marketing/help.svg'
import Box from '@material-ui/core/Box'
import Dialog from 'components/program-marketing/dialog'

function Breakdown({ hit, totalCost }) {
  const [open, setOpen] = useState(false)

  const onCloseDialog = e => {
    e.preventDefault()
    setOpen(false)
  }

  const viewAnnualMembership = e => {
    e.preventDefault()
    setOpen(true)
  }

  return (
    <>
      <Hidden xsDown implementation="css">
        <Box display="flex" alignItems="center">
          <Typography variant="body1" component="span">
            ${totalCost} Per Player + 3% Processing Fee
          </Typography>{' '}
          <Box
            display="flex"
            alignItems="center"
            mx={1}
            onClick={viewAnnualMembership}
          >
            <img src={HelpSvg} alt="fee-help" />
          </Box>
        </Box>
      </Hidden>

      <Hidden smUp implementation="css">
        <Box display="flex" alignItems="center">
          <Typography variant="body1">
            ${totalCost} Per Player + <br /> 3% Processing Fee
          </Typography>
          <Box
            display="flex"
            alignItems="center"
            mx={1}
            onClick={viewAnnualMembership}
          >
            <img src={HelpSvg} alt="fee-help" />
          </Box>
        </Box>
      </Hidden>
      <Dialog
        title="Additional Fees"
        heading="Annual Membership Cost"
        open={open}
        onClose={onCloseDialog}
        text={`PGA Jr. League players must pay a $${hit.membership_fee_in_cents /
          100} annual membership fee called the #GameChanger Club, valid for the calendar year. Payment during the spring season covers participation in any additional PGA Jr. League events within the same calendar year.`}
        headingSecondary={'3% Processing Fee'}
        textSecondary="This fee covers the cost of processing your payment through our credit card processor and helps to support the cost of operating the platform for your use."
      />
    </>
  )
}

export default function Cost({ hit }) {
  const totalCost = hit.price_in_cents / 100
  const haveBreakdown =
    hit.coaching_fee_in_cents != null && hit.membership_fee_in_cents != null

  return (
    <Typography variant="body1" component="div">
      {haveBreakdown ? (
        <Breakdown hit={hit} totalCost={totalCost} />
      ) : (
        <Typography variant="body1">${totalCost} Per Player</Typography>
      )}
    </Typography>
  )
}
